import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-bg-black">
      {/* Header Section - Updated to match Contact Us page */}
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 text-center py-16 px-4">
        <h1 className="text-4xl font-bold text-white mb-2">TEAM</h1>
        <p className="text-teal-100 max-w-2xl mx-auto">
          Meet the people behind elef89
        </p>
      </div>
      
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24 max-w-4xl mx-auto">
          <div className="flex flex-col items-center text-center">
            <p className="text-gray-400 uppercase tracking-wider mb-8 opacity-70">Co-Founder</p>
            <img 
              src="/images/david-deutsch.png"
              alt="David Deutsch" 
              className="w-64 h-64 md:w-80 md:h-80 rounded-full object-cover shadow-md transition-transform hover:scale-105 mb-6 border-8 border-white mx-auto"
              style={{objectPosition: "center 40%"}}
            />
            <div className="flex items-center gap-2">
              <p className="text-xl text-white">David Deutsch</p>
              <a 
                href="https://linkedin.com/in/david-deutsch-391917184" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="flex flex-col items-center text-center">
            <p className="text-gray-400 uppercase tracking-wider mb-8 opacity-70">Co-Founder</p>
            <img 
              src="/images/shay-deutsch.png" 
              alt="Shay Deutsch" 
              className="w-64 h-64 md:w-80 md:h-80 rounded-full object-cover shadow-md transition-transform hover:scale-105 mb-6"
            />
            <div className="flex items-center gap-2">
              <p className="text-xl text-white">Shay Deutsch</p>
              <a 
                href="https://www.linkedin.com/in/yeshayahu-deutsch-817b6624/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-lg text-gray-400 leading-relaxed mb-6">
            We are brothers who have been passionate about mobile development for over a decade.
          </p>
          <p className="text-lg text-gray-400 leading-relaxed">
            With years of hands-on experience in building, scaling, and launching apps, we know the challenges developers face — because we've faced them too. That's why we created this platform: to help others bring their apps to life with less friction and more confidence. Our journey in the mobile world has been both exciting and rewarding, and we're proud to use that experience to support others on theirs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 